import BeneficiaryForm from '@/components/AccountConfig/BeneficiaryForm/index.vue';

export default {
    name: 'Beneficiaries',
    props: ['uuid', 'status'],

    components: { BeneficiaryForm },

    data() {
        return {
            editable: false,
            uuidAccount: '',
            beneficiaries: []
        };
    },

    mounted() {
        this.uuidAccount = this.uuid;
        this.loadBeneficiariesData();
    },

    methods: {
        cancel() {
            this.editable = false;
            this.loadBeneficiariesData();
        },

        edit(index) {
            this.editable = index;
            this.loadBeneficiariesData();
        },

        update() {
            // Success notification
            this.$bvToast.toast('Se ha actualizado correctamente', {
                title: 'Actualizado',
                toaster: 'b-toaster-top-center',
                autoHideDelay: 10000,
                variant: 'success'
            });

            this.edit();
            this.loadBeneficiariesData();
        },

        loadBeneficiariesData() {
            this.$accountService
                .getBeneficiaries(this.uuidAccount)
                .then(response => {
                    this.beneficiaries = response.data.account_beneficiaries;
                })
                .catch(error => console.error(error));
        }
    },
    computed: {
        canEdit() {
            return this.status === 'FINALIZED';
        }
    }
};
